import { useEffect } from 'react';

/**
 * UiUnlockWatchdog — iOS Safari occasionally leaves the page frozen after a
 * Radix dialog closes during a re-render (e.g. the 5s live poll): the body
 * keeps `pointer-events: none`, scroll-lock attributes and aria-hidden
 * leftovers, so EVERY tap dies (back button, end live, …).
 *
 * Every 1.5s, ONLY when no overlay is actually open, we clear any orphaned
 * locks. It never touches open dialogs/menus/drawers.
 */
const OVERLAY_SELECTOR = [
  '[role="dialog"]',
  '[role="alertdialog"]',
  '[data-radix-popper-content-wrapper]',
  '[vaul-drawer]',
].join(', ');

const UiUnlockWatchdog = () => {
  useEffect(() => {
    const iv = setInterval(() => {
      try {
        if (document.querySelector(OVERLAY_SELECTOR)) return; // something is open — hands off
        const body = document.body;
        if (body.style.pointerEvents === 'none') body.style.pointerEvents = '';
        if (document.documentElement.style.pointerEvents === 'none') {
          document.documentElement.style.pointerEvents = '';
        }
        if (body.hasAttribute('data-scroll-locked')) {
          body.removeAttribute('data-scroll-locked');
          if (body.style.overflow === 'hidden') body.style.overflow = '';
          if (body.style.paddingRight) body.style.paddingRight = '';
        }
        const root = document.getElementById('root');
        if (root) {
          if (root.getAttribute('aria-hidden') === 'true') root.removeAttribute('aria-hidden');
          if (root.hasAttribute('data-aria-hidden')) root.removeAttribute('data-aria-hidden');
          if (root.style.pointerEvents === 'none') root.style.pointerEvents = '';
        }
      } catch (_e) { /* the watchdog must never throw */ }
    }, 1500);
    return () => clearInterval(iv);
  }, []);
  return null;
};

export default UiUnlockWatchdog;
